import React, { useState, useEffect, useRef } from 'react';
import './pos/Posui.css'; // Import the CSS file
import generateOrderHTML from '../reuseable/Billprint';
import Swal from "sweetalert2";
const Pos = () => {
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [cart, setCart] = useState([]);
  const [paidAmount, setPaidAmount] = useState(0);
  const [changeDue, setChangeDue] = useState(0);

  const [customers] = useState([{ id: 1, name: 'Walk-In Customer' }, { id: 2, name: 'Customer A' }, { id: 3, name: 'Customer B' }]);
  const [selectedCustomer, setSelectedCustomer] = useState(customers[0]);
  const [customerDetails, setCustomerDetails] = useState([]);
  useEffect(() => {
    const fetchResults = async () => {
      if (query.length > 0) {
        try {
          const response = await fetch(`https://pharmacy.msmatraders.com/backend/transactions/searchMed.php?query=${query}`);
          const data = await response.json();
          setResults(data);
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      } else {
        setResults([]);
      }
    };

    fetchResults();
  }, [query]);

  function generateImageUrl(path) {
    const baseUrl = "https://api.medeasy.health";
    const fullUrl = `${baseUrl}${path}`;
    return `https://medeasy.health/_next/image?url=${encodeURIComponent(fullUrl)}&w=750&q=75`;
  }

  const quantityRefs = useRef([]);
  const priceRefs = useRef([]);  // New ref for price inputs
  const searchInputRef = useRef(null); // Ref for search input
  const discountInputRef = useRef(null); // Ref for discount input
  const paidAmountInputRef = useRef(null); // Ref for paid amount input
  const saveButtonRef = useRef(null); // Ref for Save button
  const addToCart = (selectedProduct) => {
    const defaultUnit = selectedProduct.units[0];
    const updatedProduct = {
      ...selectedProduct,
      selectedUnit: defaultUnit,
      quantity: defaultUnit.unit_size,
      total: defaultUnit.price,
    };
    setCart((prevCart) => {
      const newCart = [...prevCart, updatedProduct];
      // Focus the price input of the newly added product
      setTimeout(() => {
        quantityRefs.current[newCart.length - 1]?.focus();
        quantityRefs.current[newCart.length - 1]?.select();
      }, 100);
      return newCart;
    });
  };


  const handleUnitChange = (productIndex, selectedUnitIndex) => {
    const updatedCart = [...cart];
    const product = updatedCart[productIndex];
    const selectedUnit = product.units[selectedUnitIndex];
    product.selectedUnit = selectedUnit;
    product.quantity = selectedUnit.unit_size; // Update quantity based on selected unit size
    product.total = selectedUnit.price; // Update total based on selected unit price
    setCart(updatedCart);
  };

  const handleQuantityChange = (productIndex, quantity) => {
    const updatedCart = [...cart];
    const product = updatedCart[productIndex];
    product.quantity = quantity;
    const mrp = product.selectedUnit.price / product.selectedUnit.unit_size; // Calculate M.R.P.
    product.total = mrp * quantity; // Calculate total as quantity * M.R.P.
    setCart(updatedCart);
  };

  const handleMRPChange = (productIndex, newMRP) => {
    const updatedCart = [...cart];
    const product = updatedCart[productIndex];
    const unitSize = product.selectedUnit.unit_size;
    product.selectedUnit.price = newMRP * unitSize; // Update the unit price
    product.total = newMRP * product.quantity; // Update total based on new M.R.P.
    setCart(updatedCart);
  };

  const removeFromCart = (productIndex) => {
    const updatedCart = cart.filter((_, index) => index !== productIndex);
    setCart(updatedCart);
  };


  const [subtotal, setSubtotal] = useState(0);
  const [discountValue, setDiscountValue] = useState(0);
  const [discountPercent, setDiscountPercent] = useState(0);

  useEffect(() => {
    // Calculate subtotal
    const newSubtotal = cart.reduce((total, item) => total + item.total, 0);
    setSubtotal(newSubtotal);

    // Update discountValue based on discountPercent
    const newDiscountValue = (discountPercent / 100) * newSubtotal;
    setDiscountValue(newDiscountValue || 0);
  }, [cart, discountPercent]);

  
 // Update handleDiscountChange to handle decimal inputs
const handleDiscountChange = (e) => {
    const newDiscountValue = parseFloat(e.target.value);
    setDiscountValue(newDiscountValue);
  };
  
  // Update handleDiscountPercentChange to handle decimal inputs
  const handleDiscountPercentChange = (e) => {
    const newDiscountPercent = parseFloat(e.target.value);
    setDiscountPercent(newDiscountPercent);
  };
  
  const total = subtotal - discountValue;


 // Reset all fields
 const resetAll = () => {
    setCart([]);
    setQuery('');
    setResults([]);
    setDiscountPercent(0);
    setDiscountValue(0);
    setPaidAmount(0);
    setChangeDue(0);
    setShowSearchResults(false);
    setSelectedCustomer(customers[0])
  };




  const handleCashClick = async () => {
    const cartDetails = cart.map(item => ({
        id: item.id,
        medicine_name: item.medicine_name,
        quantity: item.quantity,
        total: item.total.toFixed(2),
    }));

    const customerIndex = customerDetails.findIndex(detail => detail.id === selectedCustomer.id);

    const customerDetail = {
        s_type: 'SALE',
        ac_id: selectedCustomer.id,
        ac_name: selectedCustomer.name,
        cart: cartDetails,
        subtotal: subtotal.toFixed(2),
        discount: discountValue.toFixed(2),
        paid: paidAmount.toFixed(2),
        total: total.toFixed(2),
    };

    try {
        // Send data to the PHP backend
        const response = await fetch('https://pharmacy.msmatraders.com/backend/pharmacy/createData.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(customerDetail),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        console.log('Server Response:', data);

        // Update local state based on server response
        if (customerIndex !== -1) {
            const updatedDetails = [...customerDetails];
            updatedDetails[customerIndex] = customerDetail;
            setCustomerDetails(updatedDetails);
        } else {
            setCustomerDetails([...customerDetails, customerDetail]);
        }
        

        Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Task completed..!',
            showConfirmButton: false,
            timer: 1500
        });

        resetAll();
        console.log('Customer Transaction:', customerDetail);
    } catch (error) {
        console.error('Error:', error);
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'An error occurred!',
            text: 'Please try again.',
            showConfirmButton: true
        });
    }
};

const handleCashClickprint = async () => {
  const cartDetails = cart.map(item => ({
      id: item.id,
      medicine_name: item.medicine_name,
      quantity: item.quantity,
      total: item.total.toFixed(2),
  }));

  const customerIndex = customerDetails.findIndex(detail => detail.id === selectedCustomer.id);

  const customerDetail = {
      s_type: 'SALE',
      ac_id: selectedCustomer.id,
      ac_name: selectedCustomer.name,
      cart: cartDetails,
      subtotal: subtotal.toFixed(2),
      discount: discountValue.toFixed(2),
      paid: paidAmount.toFixed(2),
      total: total.toFixed(2),
  };

  try {
      // Send data to the PHP backend
      const response = await fetch('https://pharmacy.msmatraders.com/backend/pharmacy/createData.php', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(customerDetail),
      });

      if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log('Server Response:', data);

      // Update local state based on server response
      if (customerIndex !== -1) {
          const updatedDetails = [...customerDetails];
          updatedDetails[customerIndex] = customerDetail;
          setCustomerDetails(updatedDetails);
      } else {
          setCustomerDetails([...customerDetails, customerDetail]);
      }
      const orderHTML = generateOrderHTML(customerDetail);
      const printWindow = window.open('', '_blank');
      if (printWindow) {
        printWindow.document.write(orderHTML);
        printWindow.document.close();
        printWindow.print();
      } else {
        alert('Please allow pop-ups to print the order details.');
      }

      Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Task completed..!',
          showConfirmButton: false,
          timer: 1500
      });

      resetAll();
      console.log('Customer Transaction:', customerDetail);
  } catch (error) {
      console.error('Error:', error);
      Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'An error occurred!',
          text: 'Please try again.',
          showConfirmButton: true
      });
  }
};
  const handleCustomerChange = (e) => {
    const selected = customers.find(c => c.id === Number(e.target.value));
    setSelectedCustomer(selected);
  };
  useEffect(() => {
    // Calculate change due when paid amount or total changes
    const total = subtotal - discountValue;
    const newChangeDue = paidAmount - total;
    setChangeDue(newChangeDue);
  }, [subtotal, discountValue, paidAmount]);
  const handlePaidAmountChange = (e) => {
    const newPaidAmount = Number(e.target.value);
    setPaidAmount(newPaidAmount);
  };

  const handleKeyDown = (e, index, type) => {
    if (e.key === 'Enter') {
      if (type === 'quantity') {
        priceRefs.current[index].focus();
        priceRefs.current[index].select();
        // Focus price input
      } else if (type === 'price') {
        searchInputRef.current.focus(); 
        searchInputRef.current.select();
        // Focus search input
      }
    }
  };

  const handleKeyDownshift = (event) => {
    if (event.shiftKey) {
      discountInputRef.current?.focus();
      discountInputRef.current?.select();
    } else if (event.key === 'Enter') {
      if (document.activeElement === discountInputRef.current) {
        paidAmountInputRef.current?.focus();
        paidAmountInputRef.current?.select();
      } else if (document.activeElement === paidAmountInputRef.current) {
        saveButtonRef.current?.focus();
      }
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDownshift);
    return () => {
      document.removeEventListener('keydown', handleKeyDownshift);
    };
  }, []);


  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="row" style={{marginTop:'15px'}}>
          <div className="col-md-4">
          
            <div className="recommend-section" style={{backgroundColor:'white',padding:'5px'}}>
          
            
              <div className="table-content" style={{backgroundColor:'white',padding:'15px'}}>
               
              

              
      {/* Input Group Container */}
      <div className="input-group-container">
        {/* Search Bar */}
        <div className="search-bar">
          <input
          ref={searchInputRef}
            type="text"
            className="form-control"
            placeholder="Search by brand"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onClick={() => setShowSearchResults(true)}
          />
          {/* Close (X) Button inside Input */}
          <span
            className="close-button"
            onClick={() => setShowSearchResults(false)}
          >
            &times;
          </span>
        </div>

        {/* Calendar Button */}
        <button className="btn btn-info calendar-button">
          <span className="glyphicon glyphicon-calendar"></span> 30 Aug 2022
        </button>
      </div>

      {results.map((result, index) => (
            <div
              key={index}
              className="search-result-item"
              onClick={() => addToCart(result)}
            >
              <img
                src={generateImageUrl(result.medicine_image)}
                alt={result.medicine_name}
              />
              <div className="result-details">
                <h4>
                  {result.medicine_name} <small>{result.strength} {result.category_name}</small>
                </h4>
               
                <p className="generic">{result.generic_name}</p>
                <p className="manufacturer">{result.manufacturer_name} <span style={{fontSize:'18px'}}> <strong>{result.units[0].price/result.units[0].unit_size}</strong> tk/pcs</span></p>
              
             
              </div>
            </div>
          ))}

             
              </div>
            </div>
          </div>
          <div className="col-md-8">
            
            <div className="order-summary">
          
              <div className="flex-row">
                <h4 className='col-md-8'>Customer</h4>
                <select value={selectedCustomer.id} onChange={handleCustomerChange} className="form-control">
          {customers.map((customer) => (
            <option key={customer.id} value={customer.id}>
              {customer.name}
            </option>
          ))}
        </select>
              </div>
              <div className="scrollable-table-container" style={{padding:'5px'}}>
              <div className="">
        {cart.map((product, index) => (
          <div key={index} className="panel panel-default">
         
            <div style={{  borderRadius: '5px', padding: '5px', display: 'flex', alignItems: 'center' }}>
            <div style={{ marginRight: '10px' }}>
    <img
                src={generateImageUrl(product.medicine_image)}
                alt={product.medicine_name}
                style={{ borderRadius: '5px', width: '50px', height: '50px' }}
              />
  </div>
  <div style={{ flexGrow: 1 }}>
    <strong style={{ fontSize: '18px' }}>  {product.medicine_name}</strong> <small>{product.strength}</small>
    <div style={{ fontSize: '12px', color: '#777' }}>{product.manufacturer_name} <small> ({product.category_name})</small></div>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
  <select
                  value={product.units.indexOf(product.selectedUnit)}
                  onChange={(e) =>
                    handleUnitChange(index, parseInt(e.target.value))
                  }
                  className="form-control"
                >
                  {product.units.map((unit, unitIndex) => (
                    <option key={unitIndex} value={unitIndex}>
                      {unit.unit}
                    </option>
                  ))}
                </select>
                <input
                    type="number"
                    ref={(el) => (quantityRefs.current[index] = el)} // Assign ref
                    value={product.quantity}
                    onChange={(e) =>
                      handleQuantityChange(index, parseInt(e.target.value))
                    }
                    onKeyDown={(e) => handleKeyDown(e, index, 'quantity')}
                    className="form-control" placeholder="qty input" style={{ width: '80px', textAlign: 'center' }}
                  />

    <input
     ref={(el) => (priceRefs.current[index] = el)}  
                    type="number"
                    value={
                      product.selectedUnit.price /
                      product.selectedUnit.unit_size
                    }
                    onChange={(e) =>
                      handleMRPChange(index, parseFloat(e.target.value))
                    }
                    onKeyDown={(e) => handleKeyDown(e, index, 'price')}
                    className="form-control" placeholder="rate input" style={{ width: '80px', textAlign: 'center' }}
                  />

    <div style={{ fontSize: '18px', margin: '0 10px' }}>{product.total.toFixed(2)}</div>
    <button type="button" className="btn btn-default"   onClick={() => removeFromCart(index)}>
      <span className="glyphicon glyphicon-remove"></span>
    </button>
  </div>
</div>

         
    
          </div>
        ))}

        
      </div>
              </div>
           
              <table>
                <tbody>
                  <tr>
                    <th>Subtotal ({cart.length}) items</th>
                    <td>+ {subtotal.toFixed(2)} tk</td>
                  </tr>
                  <tr>
                    <th>Discount
                    <select
              value={discountPercent}
              onChange={handleDiscountPercentChange}
            >
              <option value="0">%</option>
              <option value="5">5%</option>
              <option value="10">10%</option>
            </select>
                    </th>
                    <td>  <input
                type="number"
                 step="0.01"
                className="editable-input"
                value={discountValue}
                onChange={handleDiscountChange}
                ref={discountInputRef}
              /></td>
                  </tr>
                  <tr>
                    <th>Total</th>
                    <td>{total.toFixed(2)}</td>
                  </tr>
                  <tr>
                    <th>Paid</th>
                    <td>  <input
                type="text"
                className="editable-input"
                value={paidAmount}
                onChange={handlePaidAmountChange}
                ref={paidAmountInputRef}
              />{" "}
              tk</td>
                  </tr>
                  <tr>
                    <th>Change</th>
                    <td><input
                type="text"
                className="editable-input"
                value={changeDue.toFixed(2)}
                readOnly
              />{" "}
              tk</td>
                  </tr>
                 
                </tbody>
              </table>
            
           
              <div className="col-md-12 " >
  <div className="row" style={{padding:'5px'}}>
    <div className="col-md-6 text-center" style={{backgroundColor: 'lightblue', padding: 5}}>
      <span style={{fontWeight: 'bold', fontSize: 20}}>Total :</span>
    </div>
    <div className="col-md-6 text-center" style={{backgroundColor: 'lightgreen', padding: 5}}>
      <span style={{fontWeight: 'bold', fontSize: 20}}>{total.toFixed(2)}</span>
    </div>
  </div>
</div>
<div className="btn-group pull-right">
  <button type="button" className="btn btn-primary" ref={saveButtonRef} onClick={handleCashClick} >
    <span className="glyphicon glyphicon-floppy-disk" /> Save
  </button>
  <button type="button" className="btn btn-success"  onClick={handleCashClickprint}>
    <span className="glyphicon glyphicon-print" /> Save &amp; Print
  </button>
  <button type="button" className="btn btn-danger" onClick={resetAll}>
    <span className="glyphicon glyphicon-refresh"  /> Reset
  </button>
</div>


            </div>
           

          </div>
        </div>
      </div>
    </div>
  );
}

export default Pos;
